import {
  SubscriberBillingHistoryEdition,
  SubscriberPaymentDetail
} from '../admin-api';

export type PaymentHistory = SubscriberPaymentDetail & {
  billings?: Array<
    SubscriberBillingHistoryEdition & {
      subscriberBillingStatusName?: string;
      editionName?: string;
    }
  >;
};
